export default {
    settings: {
        refreshTime: 1 //minute
    },
    has_altin: {
        alis_ekleme: 0,
        satis_ekleme: 0
    },
    dolar: {
        alis: {
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false
        },
        satis: {
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false
        }
    },
    euro: {
        alis: {
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false
        },
        satis: {
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false
        }
    },
    ceyrek_altin: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    yarim_altin: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    tam_altin: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    kafali_2_5lu: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    cumhuriyet_ata: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    bilezik: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    gram_1: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    '24_ayar_gram_1': {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    gram_0_5: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    gram_0_25: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    gram_0_10: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
    gram_0_05: {
        alis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        },
        satis: {
            katsayi: 1,
            kusurat_aktif: true,
            kusurat: 0,
            ekleme_aktif: true,
            ekleme: 0,
            asagi_yuvarla: false,
            yukari_yuvarla: false,
            tam_yuvarla: false,
            sonucu_carp: 1,
            sonuc_x_in_kati: null
        }
    },
}


// WEBPACK FOOTER //
// ./src/empty.js